import { Input } from "@babackapp/ui/components/input";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@babackapp/ui/components/tooltip";
import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";
import { DEFAULT_FONT } from "../../utils/constants";
import { resolveBlockFont } from "../../utils/fonts";
import { useBlockPanelPropsContext } from "./panel-container";
import PanelContent from "./panel-content";

export default function PanelBlockFont() {
  const { t } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext();
  // Empty when the block follows the theme font, shown as the placeholder.
  const font = blockProps.block.font;
  const value = font && font !== DEFAULT_FONT ? font : "";
  const info = t(
    "editorBlocksLibrary.panel.font.info",
    "Gmail and Outlook on Windows don't load Google Fonts: they show a fallback font instead.",
  );

  const handleUpdate = (font: string) => {
    blockProps.formAPI.updateField(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      font,
    });
  };

  return (
    <PanelContent
      title={t("editorBlocksLibrary.panel.font.title", "Font")}
      titleSuffix={
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              aria-label={info}
              className="text-muted-foreground transition-colors hover:text-foreground"
            >
              <Info className="h-3.5 w-3.5" />
            </button>
          </TooltipTrigger>
          <TooltipContent className="max-w-xs">{info}</TooltipContent>
        </Tooltip>
      }
    >
      <Input
        value={value}
        placeholder={resolveBlockFont(null, blockProps.theme)}
        className="w-full text-sm h-8"
        onChange={(e) => handleUpdate(e.target.value)}
      />
    </PanelContent>
  );
}
